$ = require 'jquery'
Backbone = require 'backbone'
Language = require 'lib/language'
Time = require 'lib/time'
Util = require 'lib/util'
_ = require 'underscore'
moment = require 'moment'
l = require 'lib/localize'

module.exports = Dates =
  objToDate: (year, month, day) ->
    if _.isObject(year)
      { year, month, day } = year

    # in JS Dates, month is 0-indexed; day 1-indexed
    new Date(year, month - 1, day)

  dateToObj: (date) ->
    year: date.getFullYear()
    # in JS Dates, month is 0-indexed; day 1-indexed
    month: date.getMonth() + 1
    day: date.getDate()

  getStartOfWeek: (day) ->
    moment(day).startOf('week').toDate()

  getEndOfWeek: (day) ->
    end = moment(day).endOf('week')
    if end.get('day') != 6
      # We've hit https://github.com/moment/moment-timezone/issues/260, which
      # is currently unfixed
      end.add(-1, 'days').set('hour', 23)
    end.toDate()


  getDaysOfWeek: (date) ->
    start = moment(date).startOf('week')
    [0..6].map (offset) -> start.clone().add(offset, 'days').toDate()

  getMidnightInt: (date) -> moment(date).startOf('day').valueOf()

  getFirstOfMonth: (date) -> moment(date).startOf('month').toDate()

  getLastOfMonth: (date) -> moment(date).endOf('month').toDate()

  isFirstOfMonth: (date) -> moment(date).isSame(moment(date).startOf('month'), 'day')

  isLastOfMonth: (date) -> moment(date).isSame(moment(date).endOf('month'), 'day')

  getDateDeltaString: (date, now) ->
    date = moment(date)
    now = moment(now)

    if date.isSame(now, 'day')
      if Math.abs(now.diff(date, 'seconds')) < 10
        l('just now')
      else
        date.from(now)
    else
      date.calendar(now)

  # Will display "just now" for any dates in the future.
  getPastDateDeltaString: (date, now) ->
    if moment(now).diff(date) < 0
      date = now
    Dates.getDateDeltaString(date, now)

  getDaysUntil: (date) ->
    date = moment(Dates.dateToObj(date))
    now = moment(Dates.dateToObj(new Date()))
    date.diff(now, 'days')

  getDateWithSpecificTime: (time, targetDate) ->
    new Date(
      targetDate.getFullYear()
      targetDate.getMonth()
      targetDate.getDate()
      time.getHours()
      time.getMinutes()
      time.getSeconds()
    )

  update: (context) ->
    now = new Date()

    update = (selector, transform) ->
      $(context).find(selector).each ->
        $el = $(this)
        date = $el.data('date')
        if !date?
          date = Dates.parse $el.attr('dt')
          date = Time.serverToClient(date)
          $el.data('date', date)

        if $el.hasClass('past')
          dateString = Dates.getPastDateDeltaString(date, now)
        else
          dateString = Dates.getDateDeltaString(date, now)
        transform $el, date, dateString

    update '.js-date-title[dt]', ($el, date, dateString) ->
      $el.attr('title', dateString)
      return

    update '.date[dt], .date[data-date]', ($el, date, dateString) ->
      $el.text dateString
      if !$el.is('[title]')
        $el.attr 'title', moment(date).format('LLL')
      return

    return

  parse: (s = '') -> moment(s).toDate()

  # Return a date like May 11, 2014
  toDateString: (date) ->
    date = moment(date)
    now = moment()

    # The reasoning here being that if it's Jan 11, and you're formatting a
    # date like Dec 21, you're going to assume it means the previous December,
    # not next December. If we do mean the upcoming (in 11 months) December,
    # we'll show the year.
    #
    # It's tricky to see if this logic is correct, but what we want to say is
    # that we want to hide the year when it's a date from this year, unless
    # the month is ambiguous.
    #
    # The month is ambiguous when it's more than nine months away from today --
    # which is to say that there's a month in a different year that's only
    # three months away.

    isAmbiguousMonth = Math.abs(now.diff(date, 'months')) > 9
    hideYear = date.isSame(now, 'year') && !isAmbiguousMonth

    # LLLL being the special overrided "Dec 21" type string, not what it is
    # by default in moment.js. See entry/set-date-locale.
    date.format(if hideYear then 'llll' else 'll')

  validDate: (d) -> _.isDate(d) && !isNaN(d.getTime())

_.extend Dates, Backbone.Events



// WEBPACK FOOTER //
// ./app/scripts/lib/dates.coffee